import { assertExists } from './assertExists'

/**
 * 検査対象が存在することを確認し、その値を返します。
 *
 * @template T - 検査対象の型。
 * @param value - 検査対象。
 * @param message - 例外時のメッセージ。
 * @returns 検査対象の値。
 */
export function ensureExists<T>(
  value: T | null | undefined,
  message?: string,
): T {
  assertExists(value, message)

  return value
}
